// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2haiK","bigColWidth":"Table_bigColWidth__3n4ST","biggerColWidth":"Table_biggerColWidth__3DDdr","row":"Table_row__xJEBo","col":"Table_col__2rDC1"};